import React, { useState, useEffect }from 'react';
import { useParams, useNavigate } from "react-router-dom";
import { TailSpin } from  'react-loader-spinner'
import axios from 'axios';
import SftGlobalData from '../library/SftGlobalData';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheckCircle, faExclamationTriangle, faFilePdf } from '@fortawesome/free-solid-svg-icons'
import Colors from '../library/Colors';
import { Button, SpeedDial, SpeedDialAction, SpeedDialIcon} from '@mui/material';
import { DataGridPro } from '@mui/x-data-grid-pro';
import FloatingAddButton from '../components/FloatingAddButton';
import { Add, Receipt, LocalShipping, Layers, LayersClear } from '@mui/icons-material';

const ShippingLogScreen = (props) =>  {
    const params = useParams();
    const [loading, setLoading] = useState(true);    
    const [searchValue, setSearchValue] = useState("");    
    const [log, setLog] = useState([]);
    const [newShipping, setNewShipping] = useState(false);
    let navigate = useNavigate();

    const [speedActions, setSpeedActions] = useState([
        {
            icon: <Add />,
            name: 'Create new',
            onClick: () => { navigate("/"+props.lang+"/shipping/new") }
        },
        {
            icon: <Receipt />,
            name: 'Create new from receipt',
            input: true,
            onClick: (event) => {
                let receiptId = prompt("Enter receipt ID:");
                if (receiptId === null) {
                    return;
                }
                receiptId = Number(receiptId).toString().substring(0, 10); //cast the receipt id to number than the the first 10 characters
                if (receiptId) {
                    navigate("/" + props.lang + "/shipping/" + `${receiptId}_sft`);
                }
            }
        }
    ]);

    const gridWebhookColumns = [
        {
            field: 'type',
            headerName: 'Type call',
            minWidth: 50,
            display: 'flex',
        },
        {
            field: 'receipt_nr',
            headerName: 'Reference',
            minWidth: 200,
            display: 'flex',
        },
        {
            field: 'tracking',
            headerName: 'Tracking',
            minWidth: 220,
            display: 'flex',
            renderCell: (params) => {
                const trackingCode = params.row.tracking;
                const provider = params.row.provider;
                const postalCode = params.row.payload?.zip || '';

                if (!trackingCode) return null;

                const getTrackingUrl = (code) => {
                    if (provider === 'bpost_direct' || provider === 'bpost') {
                        return `https://track.bpost.cloud/btr/web/#/search?itemCode=${code}&lang=nl&postalCode=${postalCode}`;
                    } else if (provider === 'myparcel') {
                        // TODO: Add myparcel tracking URL
                        return null;
                    } else if (provider === 'sendcloud') {
                        // TODO: Add sendcloud tracking URL
                        return null;
                    }
                    return null;
                };

                const trackingCodes = trackingCode.split(';').map(code => code.trim()).filter(code => code);

                return (
                    <span>
                        {trackingCodes.map((code, index) => {
                            const url = getTrackingUrl(code);
                            return (
                                <span key={index}>
                                    {index > 0 && '; '}
                                    {url ? (
                                        <span
                                            style={{
                                                color: Colors.sft_blue,
                                                cursor: 'pointer',
                                                textDecoration: 'underline'
                                            }}
                                            onClick={() => window.open(url, '_blank', 'noopener,noreferrer')}
                                        >
                                            {code}
                                        </span>
                                    ) : code}
                                </span>
                            );
                        })}
                    </span>
                );
            }
        },
        {
            field: 'provider',
            headerName: 'provider',
            minWidth: 300,
            display: 'flex',
        },
        {
            field: 'created_at',
            headerName: 'Created at',
            minWidth: 170,
            display: 'flex',
        },
        {
            field: 'updated_at',
            headerName: 'Modified at',
            minWidth: 170,
            display: 'flex',
        },
        {
            field: 'status',
            headerName: 'status',
            minWidth: 110,
            headerAlign: "center",
            align: "center",
            display: 'flex',
            renderCell: (params) => {
                //console.log(params.row)
                if(params.row?.status?.status === "ok"){
                    return  <Button style={{color: (props.theme === 'dark' ? Colors.dark_text : Colors.light_text), height:"20px" }} >
                                <FontAwesomeIcon icon={faCheckCircle} color="green" size="2x" />
                            </Button>;
                } else {
                    return  <Button style={{color: (props.theme === 'dark' ? Colors.dark_text : Colors.light_text), height:"20px" }} onClick={()=>{props.notify(params.row.error, 7500, "top-right", props.theme, params.row.id)}}>
                                <FontAwesomeIcon icon={faExclamationTriangle} color="red" size="2x" />
                            </Button>;
                }
            }
        },
        {
            field: 'label',
            headerName: 'label',
            minWidth: 110,
            headerAlign: "center",
            align: "center",
            display: 'flex',
            renderCell: (params) => {
                if((params.row.type === "label" || params.row.type === "shipment") && params.row?.status?.status === "ok"){
                    //console.log("url: ", params.row);
                    return <Button style={{color: (props.theme === 'dark' ? Colors.dark_text : Colors.light_text), height:"20px" }} onClick={() => getPdf(params.row.receipt_nr)}>
                                <FontAwesomeIcon icon={faFilePdf}  size="2x" />
                            </Button>
                }
                
            }
        },
      ];



    const openInNewTab = (url) => {
        const newWindow = window.open(url, '_blank', 'noopener,noreferrer')
        if (newWindow) newWindow.opener = null
    } 


    useEffect(() => {
        if(props.api !== ''){
            SftGlobalData.post('shippingLog', {key: props.api}).then(response => {
                setLog(response.data);                    
                setLoading(false);
            });   
        }
     },[props.api, params.userId]);

    useEffect(() => {
        if(props.api !== ''){
            SftGlobalData.post('shippingLog&action=fetchKasvar', {key: props.api}).then(response => {
                if(response.data["type_of_shipping"] === "BPOST2"){
                    setNewShipping(true);
                }
            });   
        }
    },[props.api, params.userId]);
    
    function openBase64NewTab(base64Pdf) {
        var blob = base64toBlob(base64Pdf);
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(blob, "pdfBase64.pdf");
        } else {
          const blobUrl = URL.createObjectURL(blob);
          window.open(blobUrl);
        }
      }
      
      function base64toBlob(base64Data) {
        const sliceSize = 1024;
        const byteCharacters = atob(base64Data);
        const bytesLength = byteCharacters.length;
        const slicesCount = Math.ceil(bytesLength / sliceSize);
        const byteArrays = new Array(slicesCount);
      
        for (let sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
          const begin = sliceIndex * sliceSize;
          const end = Math.min(begin + sliceSize, bytesLength);
      
          const bytes = new Array(end - begin);
          for (let offset = begin, i = 0; offset < end; ++i, ++offset) {
            bytes[i] = byteCharacters[offset].charCodeAt(0);
          }
          byteArrays[sliceIndex] = new Uint8Array(bytes);
        }
        return new Blob(byteArrays, { type: "application/pdf" });
      }

    function getPdf(receipt_nr){
        if(props.api !== ''){
            SftGlobalData.post('shippingLog&action=fetchPdf', {key: props.api, receipt_nr: receipt_nr}).then(response => {
                if(response.data[0].url !== undefined){
                    // Check if URL contains semicolon (multiple labels)
                    if(response.data[0].url.includes(';')) {
                        // Split URLs and open each in a new tab
                        const urls = response.data[0].url.split(';');
                        urls.forEach(url => {
                            openInNewTab(url.trim());
                        });
                    } else {
                        // Single URL
                        openInNewTab(response.data[0].url);
                    }
                } else if(response.data[0].pdf !== undefined) {
                    // Handle base64 PDFs (if your backend returns them)
                    if(response.data[0].pdf.includes(';')) {
                        // Multiple PDFs separated by semicolon
                        const pdfs = response.data[0].pdf.split(';');
                        pdfs.forEach(pdf => {
                            openBase64NewTab(pdf.trim());
                        });
                    } else {
                        // Single PDF
                        openBase64NewTab(response.data[0].pdf);
                    }
                }
            });
        }
    }

    function DataGridShippingLog() {
        return (
          <div style={{ height: 520, width: '100%' }}>
            {(log.length === 0 ? "" : <DataGridPro
                className={props.theme}
                columns={gridWebhookColumns}
                rows={log.filter(log => (log?.receipt_nr?.match(new RegExp(searchValue, "i")) || log?.action?.match(new RegExp(searchValue, "i")) || log?.payload?.first_name?.match(new RegExp(searchValue, "i")) || log?.payload?.last_name?.match(new RegExp(searchValue, "i")) || log?.payload?.email?.match(new RegExp(searchValue, "i"))))   
                .map((row, index) => {return {
                    id: row.id,
                    type: row.type,
                    receipt_nr: row.receipt_nr,
                    tracking: row.tracking,
                    created_at: SftGlobalData.dateTimeFormatter(row.created_at),
                    updated_at: SftGlobalData.dateTimeFormatter(row.updated_at),
                    provider: row.provider,
                    status: row.response,
                    error: row.response?.message,
                    url: row.url,
                    payload: row.payload
                }
                })}
                //{...data}
                loading={log.length === 0}
                rowHeight={38}
                pagination={true}
                />)}            
          </div>
        );
      }

    return (
        <div className={(props.screenWidth) < 600 ? 'not_expanded container_content _80perc ' + props.theme + ' container_content_' + props.theme : 'expanded container_content _80perc ' + props.theme + ' container_content_' + props.theme} >

            {(newShipping) && (
                <SpeedDial
                    ariaLabel="SpeedDial basic example"
                    sx={{ '& > :not(style)': { m: 1 }  }}
                    icon={<SpeedDialIcon icon={<LocalShipping />} openIcon={<Layers />}/>}
                    size="medium"
                    style={{position: 'fixed', right: 14, bottom: 24, zIndex: 10000}}>
                    {speedActions.map((action) => (
                        <SpeedDialAction
                        key={action.name}
                        icon={action.icon}
                        tooltipTitle={action.name}
                        onClick={()=>{action.onClick();}}
                        />
                    ))}
                </SpeedDial>)
            }
            <div className={"container_list__title " + props.theme}><h2>{props.t('shippingLog')}</h2></div>
            
            {loading && <div className={"container_list__title " + props.theme} style={{display:"flex", justifyContent: "space-evenly", marginTop: 5, border: 1}}>
                        <TailSpin 
                            height="40"
                            width="40"
                            color={Colors.sft_blue}
                            ariaLabel='loading'
                        />
                    </div>}
                   
            {!loading && (<div className='search'>
            {(log.length === 0 ? <p style={{textAlign:"center"}}>{props.t('noShippingHistory')}</p> : <input 
                    type="text"
                    name="search"
                    className={props.theme+"_accent_darker txt_user"}
                    placeholder={props.t('search')}
                    value={searchValue}
                    onChange={e => setSearchValue(e.target.value)}
                />)}
            </div>)}
            {!loading && (DataGridShippingLog())}
        </div>
    );
}

export default ShippingLogScreen;
